export default __webpack_public_path__ + "static/media/about-us-banner.6af305ea.webp";